


























































import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { get } from 'lodash';

export type TTabs = {
  text: string;
  slot: string;
};

@Component({
  components: {
    PatientAcquisitionComments: () => import('@/components/patients/PatientAcquisitionComments.vue'),
    ElementOverviewInterpretations: () => import('@/components/elements/ElementBlocOldInterpretation.vue'),
  },
})
export default class PatientsResultsTabs extends Vue {
  @Prop({ required: true }) private patient!: TPatient;
  @Prop({ required: true }) private acquisition!: TAcquisition;
  @Prop({ required: true }) private graph!: string;
  @Prop({ default: () => [] }) private graphSubtypes!: number[];

  @Provide() tabs: TTabs[] = [
    {
      text: 'commons.standards.average',
      slot: 'average',
    },
    {
      text: 'commons.standards.symmetry',
      slot: 'symmetry',
    },
    {
      text: 'commons.standards.variation',
      slot: 'variation',
    },
  ];
  @Provide() selectedTabIndex: number = 0;
  @Provide() selectedSecondaryTabIndex: number = 0;

  isLatestVersionAlgorithm() {
    let data = get(this.acquisition, 'computed_data.recommendations.podosmart');

    if (!data || !Array.isArray(data) || !data.length) return false;

    return data[0].id.includes('_HS');
  }
}
